import { html } from "uhtml";
import { locales } from "../../models/locales.js";
import {
	autoHideToolbar,
	disableAnimation,
} from "../../view-models/app-signals.js";

document.addEventListener("animationend", function (event) {
	if (event.target.id === "right-icon") {
		event.target.removeAttribute("style");
	}
});

export function desktopHints(locale = "en") {
	const disable = disableAnimation();
	const animationDelay = autoHideToolbar();
	const style = !disable
		? `border-radius:100%; background-color: transparent; animation: 500ms ease-in-out ${animationDelay}ms autohideblink 3; outline: none; display: block !important;`
		: "";
	return html`<div class="desktop-hints" aria-hidden="false">
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 19 19" preserveAspectRatio="xMidYMid meet" role="img" class="icon hint left-hint" aria-labelledby="left-icon">
  <title id="left-icon">${locales.previousPage[locale]}</title>
  <path d="M10.92 5.865a.306.306 0 0 0-.432 0L7.1 9.253a.492.492 0 0 0 0 .694l3.388 3.388a.305.305 0 1 0 .432-.433L7.617 9.6l3.303-3.303a.306.306 0 0 0 0-.432z"></path>
</svg>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 19 19" preserveAspectRatio="xMidYMid meet" role="img" class="icon hint right-hint" aria-labelledby="right-icon" id="right-icon" style="${style}">
  <title id="right-icon">${locales.nextPage[locale]}</title>
  <path d="M8.08 13.335a.306.306 0 0 0 .432 0L11.9 9.947a.494.494 0 0 0 0-.694L8.512 5.865a.306.306 0 0 0-.432.432L11.383 9.6 8.08 12.902a.305.305 0 0 0 0 .433z"></path>
</svg>
  </div>`;
}
